import { createSelector } from 'reselect';

const location = (state) => state.location;

export const getLocation = createSelector([location], (location) => location);

export default {
  getLocation,
};
